import { render, staticRenderFns } from "./InvoiceCustomizer.vue?vue&type=template&id=46b070a8&scoped=true"
import script from "./InvoiceCustomizer.vue?vue&type=script&lang=js"
export * from "./InvoiceCustomizer.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCustomizer.vue?vue&type=style&index=0&id=46b070a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b070a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
